var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indicator-chart"},[_c('x-loading',{attrs:{"visible":_vm.loading}},[_c('span',{staticClass:"indicator-chart-text",style:(_vm.calcStyle)},[_vm._v(_vm._s(_vm.indicator))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }